const markPathAsSelected = (state, path = '') => {
  const list = path
    .replace('node.nodes.', '')
    .split('.')
    .reduce((acc, id) => ({ ...acc, [id]: true }), {})

  state.set(`node.selectedList`, list)
}

export default markPathAsSelected



// WEBPACK FOOTER //
// ./src/modules/Node/helpers/markPathAsSelected.js